import React, { useState, useEffect, useRef } from "react";
import { Paginado } from "../../components/Paginado";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import bannerBlog from "../../img/landing_comprimidas/banner_blog.webp";
interface Blog {
    id: number;
    titulo: string;
    banner: string;
    contenido: string;
    fecha_publicado: Date;
}

interface getParams {
    pagina: number;
    habilitado: string;
    query: string;
    etiqueta: number;
}

interface etiquetaBlog {
    id: number;
    nombre: string;
    habilitado: string;
    fecha_registro: string;
}

const PrincipalContent = () => {
    const [blogs, setBlogs] = useState<Blog[]>([]);
    const [pageNumber, setpageNumber] = useState<number>(1);
    const [blogsTotal, setBlogsTotal] = useState<number>(0);
    const blogs_PER_PAGE = 8;
    const [order, setOrder] = useState("Desc");
    const [input, setInput] = useState<string>("");
    const [etiquetaSelect, setEtiquetaSelect] = useState(0);
    const [etiquetasBLogs, setEtiquetasBlogs] = useState<etiquetaBlog[]>([]);
    const navigate = useNavigate();
    const debounceInput = useRef<ReturnType<typeof setTimeout> | null>(null);
    const [blogPrincipal, setBlogPrincipal] = useState<Blog | null>(null);
    const principalRef = useRef<HTMLDivElement | null>(null);
    const [principalHeight, setPrincipalHeight] = useState<number>(0);

    useEffect(() => {
        if (principalRef.current) {
            setPrincipalHeight(principalRef.current.offsetHeight);
        }
    }, [blogPrincipal]);

    const getBlogs = async ({
        pagina,
        habilitado,
        query,
        etiqueta,
    }: getParams) => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_PROXY}/blog/getAll/${pagina}/${habilitado}/${order}/${etiqueta}?query=${query}`
            );
            console.log(data);
            const principal = blogPrincipal ? blogPrincipal : data.rows[0];
            setBlogPrincipal(principal);
            setBlogs(data.rows.slice(1));
            setBlogsTotal(data.count);
        } catch (error) {
            console.log(error);
        }
    };

    const getEtiquetaBlog = async () => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_PROXY}/etiquetas_blogs/getAll/1/Si?query=`
            );

            console.log(data);
            setEtiquetasBlogs(data.rows);
            // setEtiquetasTotal(data.count);
        } catch (error) {
            console.log(error);
        }
    };

    const pagination = (pageNumber: number) => {
        setpageNumber(pageNumber);
        getBlogs({
            pagina: pageNumber,
            habilitado: "Si",
            query: "",
            etiqueta: etiquetaSelect,
        });
    };

    useEffect(() => {
        getEtiquetaBlog();
    }, []);

    useEffect(() => {
        getBlogs({
            pagina: pageNumber,
            habilitado: "Si",
            query: "",
            etiqueta: etiquetaSelect,
        });
    }, [pageNumber, order, etiquetaSelect]);

    return (
        <div>
            <div>
                <div className=" pt-20  md:pt-32 text-2xl sm:text-3xl lg:text-5xl text-[#071829] text-center sm:text-left font-bold 3xl:w-2/3 2xl:w-3/4 lg:w-4/5 w-5/6  mx-auto">
                    <p>
                        Lee nuestro blog y transforma la gestión de tu
                        alojamiento
                    </p>
                    <p className="font-normal text-base sm:text-lg lg:text-xl mt-4 text-[#071829]  text-center sm:text-left">
                        Encuentra tips, estrategias y novedades que te ayudarán
                        a optimizar tu propiedad al máximo.
                    </p>
                </div>
            </div>

            {blogPrincipal && (
                <div className="flex flex-col w-5/6 gap-4 mx-auto my-6 lg:flex-row 3xl:w-2/3 2xl:w-3/4 lg:w-4/5">
                    <div
                        ref={principalRef}
                        className="bg-[#FAFAFB] rounded-lg p-5 w-full lg:w-[55%]"
                    >
                        <div className="flex-col items-center justify-center w-full rounded-lg">
                            <img
                                src={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/blog/getBanner/${blogPrincipal.banner}`}
                                alt="blog"
                                className="h-[30vh] sm:h-[40vh] w-full rounded-xl object-cover"
                            />
                            <div className="px-2 mt-3 text-xl lg:text-2xl xl:text-[27px] font-bold text-[#071829]">
                                {blogPrincipal.titulo}
                            </div>

                            <div className="px-2 mt-3 text-base lg:text-lg xl::text-xl text-[#071829]">
                                {blogPrincipal.contenido
                                    .replace(/<[^>]*>?/g, "")
                                    .replace(".", ". ")
                                    .split(" ", 15)
                                    .join(" ")}
                            </div>
                            <div className="flex justify-end mt-4">
                                <button
                                    onClick={() =>
                                        navigate(`/blog/${blogPrincipal.id}`)
                                    }
                                    className="bg-[#44C7FF] text-white font-semibold rounded-lg px-4 py-2 gap-4 mt-3 text-base lg:text-lg flex items-center justify-center hover:bg-[#1C4CBB] transition duration-300 ease-in-out"
                                >
                                    Lees más
                                    <svg
                                        width="10"
                                        height="17"
                                        viewBox="0 0 10 17"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.375 16.125C1.05859 16.125 0.777344 16.0195 0.566406 15.8086C0.109375 15.3867 0.109375 14.6484 0.566406 14.2266L6.50781 8.25L0.566406 2.30859C0.109375 1.88672 0.109375 1.14844 0.566406 0.726562C0.988281 0.269531 1.72656 0.269531 2.14844 0.726562L8.89844 7.47656C9.35547 7.89844 9.35547 8.63672 8.89844 9.05859L2.14844 15.8086C1.9375 16.0195 1.65625 16.125 1.375 16.125Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div
                        className="flex flex-col rounded-lg w-full lg:w-[45%]"
                        style={{
                            maxHeight: `${principalHeight}px`,
                            overflowY: "auto",
                            overflowX: "hidden",
                        }}
                    >
                        <div className="flex flex-col w-full gap-3 px-1">
                            {blogs &&
                                blogs.length > 0 &&
                                blogs.map((blog) => (
                                    <div
                                        key={blog.id}
                                        onClick={() =>
                                            navigate(`/blog/${blog.id}`)
                                        }
                                        className="grid sm:grid-cols-[40%,60%] gap-2 rounded-lg cursor-pointer mt-6 sm:mt-1"
                                    >
                                        <img
                                            src={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/blog/getBanner/${blog.banner}`}
                                            alt="blog"
                                            className="h-[10rem] w-full rounded-lg object-cover"
                                        />
                                        <div className="flex flex-col w-full h-full px-2 mt-3 sm:mt-1">
                                            <div className=" text-base xl:text-lg font-bold text-[#071829]">
                                                {blog.titulo}
                                            </div>
                                            <div className="mt-2 sm:mt-1 text-xs xl:text-sm text-[#071829]">
                                                {blog.contenido
                                                    .replace(/<[^>]*>?/g, "")
                                                    .replace(".", ". ")
                                                    .split(" ", 15)
                                                    .join(" ")}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>

                        <div className="py-3 mt-auto">
                            <Paginado
                                elementsPerPage={blogs_PER_PAGE}
                                cantTotalElements={blogsTotal}
                                pagination={pagination}
                                actualPage={pageNumber}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PrincipalContent;
